module.exports = __webpack_public_path__ + "img/icon_vr_gold.aaea2198.gif";